import { render, staticRenderFns } from "./RPComparisonCard.vue?vue&type=template&id=e617e168&"
import script from "./RPComparisonCard.vue?vue&type=script&lang=js&"
export * from "./RPComparisonCard.vue?vue&type=script&lang=js&"
import style0 from "./RPComparisonCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports